import styled from 'styled-components'
import {
  FONT_SIZE,
  COLOR,
  Z_INDEXS,
} from '../../themes'
import { colorThemeSelector } from '../../helpers'
const Style = styled.div`
  z-index: ${Z_INDEXS.LV_MAX};
  width: 100%;
  height: 100%;
  background-color: #000000AA;
  position: fixed;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  scroll-behavior: smooth;
  top: 0;
  left: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -ms-user-select: none;
  user-select: none;
  scrollbar-width: none;
  .timePicker {
    background-color: ${COLOR.WHITE};
    width: 300px;
    height: 400px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    padding: 12px;
    border-radius: 3px;
  }
  .timePicker hr{
    position: relative;
    top: auto;
    left: auto;
    margin: 3px 0;
    padding: 0;
    width: none;
    align-self: stretch;
    border: 2px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    border-radius: 6px;
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }
  .timePicker hr.lightLine{
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }
  .timeHeader {
    color: ${COLOR.BLACK_1};
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    align-items: center;
  }
  .timeButtons h3,
  .timeHeader h1 {
    text-transform: uppercase;
    padding: 0;
    margin: 0;
  }
  .timeHeader h1 {
    font-family: NunitoBold;
    font-size: ${FONT_SIZE.SM};
    border-bottom: 4px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    flex: 1;
    text-align: center;
    padding: 0 0 4px 0;
    margin: 0 3px;
    border-radius: 3px;
  }
  .timeButtons > button,
  .timeHeader button {
    flex: 1;
    padding: 6px;
    margin: 0;
    border: 2px solid ${COLOR.WHITE};
    transition: color 30ms ease-out, background-color 30ms ease-out, border 30ms ease-out;
    background-color: ${COLOR.WHITE};
    border-radius: 3px;
    color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    outline: 0px;
  }
  .timeHeader button:active {
    color: ${COLOR.WHITE};
    background-color: ${COLOR.Sky_1};
  }
  .timeButtons {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
  }
  .timeButtons > button {
    flex: 0;
    min-width: 64px;
    max-width: 64px;
    height: 30px;
    line-height: 1em;
    margin-left: 3px;
    color: ${COLOR.WHITE};
    font-size: 10px;
    cursor: pointer;
  }
  .timeButtons > button.saveButton {
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    border-radius: 4px;
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT || COLOR.BLACK_1};
  }
  .timeButtons > button.closeButton {
    background-color: black;
    border-radius: 4px;
  }
  .timeButtons > button.saveButton:hover {
    border: 2px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    border-radius: 3px;
  }
  .timeButtons > button.saveButtonDisable:disabled {
    background-color: ${COLOR.PEARL};
    border: 2px solid ${COLOR.PEARL};
    color: ${COLOR.BLACK_1};
    cursor: not-allowed;
  }
  .timeButtons > button.closeButton:hover {
    border: 2px solid black;
    border-radius: 3px;
  }
  .timeButtons > button.saveButton:active {
    border: 2px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }
  .timeButtons > button.closeButton:active {
    border: 2px solid ${COLOR.GRAY_3};
    background-color: ${COLOR.GRAY_3};
  }
  .upsideDown {
    transform: rotate(180deg);
  }
  .timeField {
    flex: 1;
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: stretch;
    flex-flow: row nowrap;
    text-align: center;
    overflow: hidden;
  }
  .timeField::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  .timeField > .hourField,
  .timeField > .minuteField  {
    display: flex;
    justify-content: stretch;
    align-items: stretch;
    flex-flow: column nowrap;
    width: 100%;
    height: 100%;
  }
  .timeArrow {
    flex: 1;
    max-height: 25px;
    min-height: 25px;
    width: 25px;
    padding: 0;
    margin: 3px auto;
    color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    background-color: transparent;
    border: none;
    outline: none;
    border-radius: 50%;
    cursor: pointer;
  }
  .timeArrow:hover {
    color: black;
    fill: black;
    stroke: black;
    background-color: transparent;
  }
  .timeArrow:focus {
    color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    fill: ${COLOR.WHITE};
    stroke: ${COLOR.WHITE};
    border-top: 1px solid ${COLOR.GRAY_1};
  }
  .timeArrow:active {
    color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    fill: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    stroke: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    background-color: transparent;
  }
  .timeArrow > * {
    width: 100%;
    height: 100%;
  }
  .timeField > .hourField > .hourSection,
  .timeField > .minuteField > .minuteSection {
    flex: 0;
    overflow-y: scroll;
    width: 100%;
    max-height: calc(100% - 60px);
    min-height: calc(100% - 60px);
    display: flex;
    flex-flow: column nowrap;
    justify-content: stretch;
    align-items: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
    user-select: none;
    scrollbar-width: none
  }
  .timeField > .minuteField > .minuteSection::-webkit-scrollbar,
  .timeField > .hourField > .hourSection::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  .timeField button.timeButton{
    border: 1px solid transparent;
    color: black;
    background-color: transparent;
    width: 90%;
    min-height: 45px;
    max-height: 45px;
    margin: 2.5px auto;
    padding: 10px;
    outline: none;
    border-radius: 3px;
    cursor: pointer;
  }
  .timeField button.timeButton > h1{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-size: 20px;
  }
  .timeField button.timeButton.selectTime:not([disabled]) {
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT || COLOR.BLACK_1};
  }
  .timeField button.timeButton:not([disabled]):hover {
    color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }
  .timeField button.timeButton.selectTime:not([disabled]):hover {
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT || COLOR.BLACK_1};
  }
  .timeField:active button.timeButton:not([disabled]):hover{
    border: 1px solid transparent;
    color: black;
    background: transparent;
  }
  .timeField button.timeButton.selectTime:not([disabled]):active
  .timeField:active button.timeButton:not([disabled]):active,
  .timeField button.timeButton.currentCar:not([disabled]):active {
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }
  .timeField button.timeButton:disabled {
    color: ${COLOR.GRAY_5};
    cursor: not-allowed;
  }
  .spaceAdder {
    background-color: transparent;
    min-height: 115px;
    max-height: 115px;
    width: 100%;
    margin: 0;
    padding: 0;
  }
  .jump-in {
    animation-timing-function: ease-out;
    animation-duration: 800ms;
    animation-name: jump-in;
    animation-iteration-count: 1;
    animation-direction: normal;
  }
  @keyframes jump-in {
    0% {
      max-height: 0vh;
      max-width: 0vw;
      top: 50%;
      left: 50%;
      opacity: 0;
    }
    100% {
      max-height: 100vh;
      max-width: 100vw;
      top: 0;
      left: 0;
      opacity: 1;
    }
  }
`

export default Style
